import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  widgetContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '80vw',
    backgroundColor: theme.palette.background.default,
    position: 'relative',
    borderRadius: '8px',
    zIndex: 1
  }
}))
export default useStyles
